import {Injectable} from '@angular/core';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import {MatSnackBar} from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class FileService {
  private readonly MAX_ROWS_PER_FILE = 20000;
  
  getMaxRowsPerFile(): number {
    return this.MAX_ROWS_PER_FILE;
  }

  constructor(private _snackBar: MatSnackBar) {}  exportExcel(data: any[], name: any) {
    if (!data || data.length === 0) {
      this._snackBar.open('No data available to export', 'Dismiss');
      return;
    }

    if (data.length > this.MAX_ROWS_PER_FILE) {
      this._snackBar.open(
        "Sorry, amount of data is too large to generate file. Please use filters",
        'Dismiss',
        { duration: 8000 }
      );
      return;
    }
    
    try {      
      const exportData = data.map(item => {
        const cleanItem = {...item};
        
        Object.keys(cleanItem).forEach(key => {
          if (cleanItem[key] === null || cleanItem[key] === undefined) {
            cleanItem[key] = '';
          }
          else if (cleanItem[key] instanceof Date) {
            cleanItem[key] = cleanItem[key].toLocaleDateString();
          }
          else if (typeof cleanItem[key] === 'object') {
            cleanItem[key] = JSON.stringify(cleanItem[key]);
          }
        });
        
        return cleanItem;
      });
      
      const worksheet = XLSX.utils.json_to_sheet(exportData);
      const workbook = {Sheets: {'Sheet1': worksheet}, SheetNames: ['Sheet1']};
      const excelBuffer: any = XLSX.write(workbook, {bookType: 'xlsx', type: 'array'});
      this.saveAsExcelFile(excelBuffer, name);
            
      this._snackBar.open(
        'File exported successfully',
        'Dismiss',
        { duration: 3000 }
      );
    } catch (error) {
      this._snackBar.open(
        'Error creating Excel file. Please try again with different data.',
        'Dismiss',
        { duration: 5000 }
      );
    }
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    let EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], {type: EXCEL_TYPE});
    
    try {
      const timestamp = new Date().getTime();
      const sanitizedFileName = fileName.replace(/[^a-z0-9_-]/gi, '_');
      const finalFileName = `${sanitizedFileName}_export_${timestamp}${EXCEL_EXTENSION}`;
      
      FileSaver.saveAs(data, finalFileName);
    } catch (error) {
      this._snackBar.open(
        'Error downloading file. Please try again or use a different browser.',
        'Dismiss',
        { duration: 5000 }
      );
    }
  }
}